export enum PREVIOUS_INSURANCE_MISS_MATCH_TYPE {
  OK = 'ok',
  OVERLAP = 'overlap',
  GAP = 'gap',
}
